<template>
    <div>
        <v-tab
            v-for="(idioma, index) in listaIdiomas"
            @click="seleccionIdioma(index, idioma)"
            class="font-weight-bold"
            style="color: #1b6cff; text-transform:none"
        >
            {{ idioma.nombre }}
        </v-tab>
        <v-menu v-model="menuIdiomas" offset-y v-if="false">
            <template v-slot:activator="{ on, attrs }">
                <v-btn class="text-capitalize" v-bind="attrs" v-on="on" text>
                    <v-icon left>fa-language</v-icon>
                    {{ idiomaActivo }}
                    <v-icon small right>fa-caret-down</v-icon>
                </v-btn>
            </template>
            <v-list dense>
                <v-list-item
                    v-for="(idioma, index) in listaIdiomas"
                    :key="index"
                    @click="seleccionIdioma(index, idioma)"
                >
                    <v-list-item-title>{{ idioma.nombre }}</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
    </div>
</template>

<script>
export default {
    name: "SelectorIdioma",
    components: {},

    data: function () {
        return {
            menuIdiomas: false,
            indexIdioma: 0,
            listaIdiomas: [
                {
                    codigo: "es",
                    nombre: this.$t("componentes.selector-idioma.castellano"),
                },
                {
                    codigo: "va",
                    nombre: this.$t("componentes.selector-idioma.valenciano"),
                },
            ],
        };
    },
    computed: {
        idiomaActivo() {
            return (
                this.listaIdiomas.find((idioma) => idioma.codigo == this.$i18n.locale)
                    .nombre ?? ""
            );
        },
    },
    methods: {
        seleccionIdioma(index, idioma) {
            let urlSeparada = window.location.pathname.split("/");
            urlSeparada[1] = idioma.codigo;
            window.location.pathname = urlSeparada.join("/");
        },
    },
};
</script>
